import { isEmpty } from 'lodash';
import { useEffect } from 'react';

import useErrorReportingStore from '../../store/errorReportingStore/useErrorReportingStore';
import useFeatureStore from '../../store/featureStore/useFeatureStore';
import useLeadChannelStore from '../../store/leadChannelStore/useLeadChannelStore';
import useUserStore from '../../store/userStore/useUserStore';

const ErrorReportingGuard = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const { user } = useUserStore();
  const { lastInteractedFlags } = useFeatureStore();
  const {
    computed: { brand },
  } = useLeadChannelStore();
  const { setAdditionalData, setUser } = useErrorReportingStore();

  useEffect(() => {
    if (user) {
      setUser({ id: user.id, email: user.primaryEmailAddress });
    }
  }, [user]);

  useEffect(() => {
    if (!isEmpty(lastInteractedFlags)) {
      setAdditionalData(lastInteractedFlags);
    }
  }, [lastInteractedFlags]);

  useEffect(() => {
    setAdditionalData({ brand });
  }, [brand]);

  return children;
};

export default ErrorReportingGuard;
